import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const fetchingSuccess = response => ({
  type: types.FETCHING_SUCCESS,
  response,
});
